/**
 * PhysicalBone3D registration: the parser.
 *
 * It reuses the Node3D parse, and property knowledge lives in linterParser.ts. It
 * draws nothing by design (ADR-0008), so index.r3f.ts registers Node3D and its children
 * still land in the right transform space.
 */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseNode3D } from '../../../base/node3d/parser';
const physicalBone3DRegistration = {
    typeName: 'PhysicalBone3D',
    parser: parseNode3D,
};
nodeRegistry.register(physicalBone3DRegistration);
//# sourceMappingURL=index.js.map